import Dropdown from "app/components/Dropdown";
import { CheckIcon } from "app/components/Icons";
import { PriorityFilterEnum } from "app/types";
import React from "react";
import { priorityOptions } from "../containers/Boards/data";

interface CustomProps {
  value?: PriorityFilterEnum;
  setValue?: (value: PriorityFilterEnum) => void;
  trigger: React.ReactNode;
  align?: "start" | "end" | "center";
  isHeader?: string;
  dropDownStyle?: React.CSSProperties;
  dropDownClassName?: string;
  className?: string;
  onOpen?: () => void;
  onClose?: () => void;
  isShowArrow?: boolean;
  titleClassName?: string;
}

const CommonPrioritySelection: React.FC<CustomProps> = ({
  setValue,
  value,
  trigger,
  align = "center",
  isHeader,
  dropDownClassName,
  dropDownStyle,
  onOpen,
  onClose,
  className,
  isShowArrow = false,
  titleClassName,
}) => {
  const MenuItems = priorityOptions?.map((ele) => {
    if (ele)
      return {
        label: (
          <div
            className={`flex items-center justify-between hover:bg-gray-50 rounded-md transition-colors w-full  ${className}`}
            aria-label={`Profile of ${ele.label}`}
          >
            {/* Left: Icon + Text */}
            <div className="flex items-center gap-[4px]">
              {ele.icon}
              <span
                className={`${titleClassName} text-sm font-normal text-black`}
              >
                {ele.label}
              </span>
            </div>

            {/* Right: Tick icon only if selected */}
            {value === ele.value && <CheckIcon color="#5A8DF1" />}
          </div>
        ),
        action: () => {
          setValue && setValue(ele?.value);
        },
      };
    else return { label: "", action: () => {} };
  });
  return (
    <Dropdown
      trigger={trigger}
      projectInfoIcon={
        <div className="flex flex-col gap-2">
          {isHeader && (
            <div className="flex items-center justify-between px-4 py-3 text-secondary tracking-[0.56px] text-sm font-semibold leading-[21px] uppercase ">
              <span>{isHeader}</span>
            </div>
          )}
        </div>
      }
      menuItems={MenuItems ? MenuItems : []}
      align={align}
      className={`py-2 ${className} `}
      dropDownClassName={`py-2 ${dropDownClassName} `}
      style={dropDownStyle}
      onClose={onClose}
      onOpen={onOpen}
      showTooltipArrowIcon={isShowArrow}
    />
  );
};

export default CommonPrioritySelection;
